/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: RouterDefine.ts
 * Created by: chan.ying
 * Create Date: 2026-08-03 11:11
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export enum RouterPathDefineEnum {
    // ------------------------------ dashboard ------------------------------
    Dashboard = "/",

    // ------------------------------ user ------------------------------
    UserList = "/users",
    UserAdd = "/users/add",
    UserEdit = "/users/detail/:userId",

    // ------------------------------ device req policy ------------------------------
    DevReqList = "/device-requirement-policy",
    DevReqAdd = "/device-requirement-policy/add",
    DevReqEdit = "/device-requirement-policy/:policyId",

    // ------------------------------ group ------------------------------
    GroupList = "/groups",
    GroupAdd = "/groups/add",
    GroupEdit = "/groups/:groupId",

    // ------------------------------ device ------------------------------
    DevicesList = "/devices",
    DeviceEdit = "/devices/:id",

    // ------------------------------ resource ------------------------------
    ResourceList = "/resources",
    ResourceAdd = "/resources/add",
    ResourceEdit = "/resources/:resourceId",

    // ------------------------------ secure network ------------------------------
    SecureList = "/secure-network",
    SecureNetWorkAdd = "/secure-network/add",
    SecureNetWorkEdit = "/secure-network/:secureNetworkId",

    // ------------------------------ saved policy ------------------------------
    SavedPolicyList = "/saved-policy",
    SavedPolicyAdd = "/saved-policy/add",
    SavedPolicyEdit = "/saved-policy/:policyId",

    // ------------------------------ role and admin ------------------------------
    RolesList = "/roles",
    RolesAdd = "/roles/add",
    RolesEdit = "/roles/:roleId",
    AssignRole = "/roles/assign-role/:roleId",
    ViewAssignee = "/roles/view-assignee/:roleId/:name",
    ViewGranter = "/roles/view-granters/:roleId/:name",
    ViewAssignment = "/roles/view-assignment/:assignmentId/:roleName",
    ViewGrantDetails = "/view-grant-details/:deletableRoleId",
    UserReceivedRolesList = "/user-received-roles/:userId/:userEmail",
    ReceivedRolesList = "/roles/:userId/:userEmail",
    CurrentUserRoles = "/user-received-roles",

    // ------------------------------ geo proxy policy ------------------------------
    GeoProxyPolicy = "/geo-proxy-policy",
    GeoProxyPolicyAdd = "/geo-proxy-policy/add",
    GeoProxyPolicyEdit = "/geo-proxy-policy/:policyId",

    // ------------------------------ resource section ------------------------------
    ResourceSectionList = "/resource-section",
    ResourceSectionAdd = "/resource-section/add",
    ResourceSectionEdit = "/resource-section/:resSectionId",
    ResourceSectionIdentities = "/resource-section/:resSectionId/:resSectionName/identities",
    ResourceSectionRoles = "/resource-section/:resSectionId/:resSectionName/roles",
    ResourceSectionRolesCreate = "/resource-section/:resSectionId/:resSectionName/roles/add",

    // ------------------------------ location ------------------------------
    LocationList = "/location",
    LocationEdit = "/location/:locationId",
    LocationAdd = "/location/add",

    // ------------------------------ network access policy ------------------------------
    PolicyList = "/network-access-policy",
    AccessPolicyAdd = "/network-access-policy/add",
    AccessPolicyEdit = "/network-access-policy/:policyId",

    // ------------------------------ predefined list ------------------------------
    IpMacList = "/ipMac-list",
    IpMacListAdd = "/ipMac-list/add",
    IpMacListEdit = "/ipMac-list/:ipMacListId",
    DeviceIdList = "/deviceId-list",
    DeviceListAdd = "/deviceId-list/add",
    DeviceListEdit = "/deviceId-list/:listId",
    LoginIdList = "/loginId-list",
    LoginListAdd = "/loginId-list/add",
    LoginListEdit = "/loginId-list/:loginListId",

    // ------------------------------ uGate ------------------------------
    UGateList = "/uGate",
    UGateAdd = "/uGate/add",
    UGateEdit = "/uGate/:uGateId",

    // ------------------------------ connector ------------------------------
    ConnectorList = "/connector",
    ConnectorAdd = "/connector/add",
    ConnectorEdit = "/connector/:connectorId",

    // ------------------------------ client agent setting ------------------------------
    ClientAgent = "/client-agent-setting",

    // ------------------------------ team setting ------------------------------
    TeamSetting = "/team-setting",

    // ------------------------------ idp integration ------------------------------
    IdPIntegration = "/identity-providers/list",
    MicrosoftIdpAdd = "/identity-providers/add/microsoft_idp",
    GoogleIdpAdd = "/identity-providers/add/googole_idp",
    GithubIdpAdd = "/identity-providers/add/github_idp",
    IdpEdit = "/identity-providers/:idpId",

    // ------------------------------ client application ------------------------------
    ClientList = "/client-application",
    ClientApplicationAdd = "/client-application/add",
    ClientApplicationEdit = "/client-application/edit/:applicationId",

    // ------------------------------ sys log ------------------------------
    UserLog = "/user-log",
    DeviceLog = "/device-log",
    ResourceLog = "/resource-log",

    // ------------------------------ my menu ------------------------------
    Profile = "/profile",

    // ------------------------------ otp ------------------------------
    OtpAcquire = "/otp/acquire/:device_uid/:operate",

    // ------------------------------ totp ------------------------------
    TotpAuth = "/totp-authentication",
    RecoveryCodes = "/totp-authentication/recovery-codes",
    RecoveryCodesView = "/totp-authentication/recovery-codes/:view",
    RecoveryCodesPrint = "/totp-authentication/recovery-codes/print",

    // ------------------------------ notification ------------------------------
    NotificationList = "/notification-list",
    NotificationDetail = "/notification-detail/:id",

    // ------------------------------ error ------------------------------
    Error403 = "/403",
    Error404 = "/404",
    Error500 = "/500",
}

export enum RouterNameDefineEnum {
    // ------------------------------ dashboard ------------------------------
    Dashboard = "default",

    // ------------------------------ user ------------------------------
    UserList = "userList",
    UserAdd = "userAdd",
    UserDetail = "userDetail",

    // ------------------------------ device req policy ------------------------------
    DevReqList = "devReqList",
    DevReqAdd = "devReqAdd",
    DevReqEdit = "devReqEdit",

    // ------------------------------ group ------------------------------
    GroupList = "groupList",
    GroupAdd = "groupAdd",
    GroupEdit = "groupEdit",

    // ------------------------------ device ------------------------------
    DevicesList = "devicesList",
    DeviceEdit = "deviceEdit",

    // ------------------------------ resource ------------------------------
    ResourceList = "resourceList",
    ResourceAdd = "resourceAdd",
    ResourceEdit = "resourceEdit",

    // ------------------------------ secure network ------------------------------
    SecureList = "secureList",
    SecureNetWorkAdd = "addSecureNetWork",
    SecureNetWorkEdit = "editSecureNetWork",

    // ------------------------------ saved policy ------------------------------
    SavedPolicyList = "savedPolicyList",
    SavedPolicyAdd = "savedPolicyAdd",
    SavedPolicyEdit = "editSavedPolicy",

    // ------------------------------ role and admin ------------------------------
    RolesList = "rolesList",
    RolesAdd = "rolesAdd",
    RolesEdit = "rolesEdit",
    AssignRole = "assignRole",
    ViewAssignee = "viewAssignee",
    ViewGranter = "viewGranter",
    ViewAssignment = "viewAssignment",
    ViewGrantDetails = "viewGrantDetails",
    UserReceivedRolesList = "userReceivedRolesList",
    ReceivedRolesList = "receivedRolesList",
    CurrentUserRoles = "currentUserRoles",

    // ------------------------------ geo proxy policy ------------------------------
    GeoProxyPolicy = "geoProxyPolicy",
    GeoProxyPolicyAdd = "addProxyPolicy",
    GeoProxyPolicyEdit = "editProxyPolicy",

    // ------------------------------ resource section ------------------------------
    ResourceSectionList = "resourceSectionList",
    ResourceSectionAdd = "resourceSectionAdd",
    ResourceSectionEdit = "resourceSectionEdit",
    ResourceSectionIdentities = "resourceSectionIdentities",
    ResourceSectionRoles = "resourceSectionRoles",
    ResourceSectionRolesCreate = "resourceSectionRolesCreate",

    // ------------------------------ location ------------------------------
    LocationList = "locationList",
    LocationEdit = "editLocation",
    LocationAdd = "addLocation",

    // ------------------------------ network access policy ------------------------------
    PolicyList = "policyList",
    PolicyAdd = "policyAdd",
    PolicyEdit = "policyEdit",

    // ------------------------------ predefined list ------------------------------
    IpMacList = "ipMacList",
    IpMacListAdd = "addIpMacList",
    IpMacListEdit = "editIpMacList",
    DeviceIdList = "deviceIdList",
    DeviceListAdd = "addDeviceList",
    DeviceListEdit = "editDeviceList",
    LoginIdList = "loginIdList",
    LoginListAdd = "addLoginList",
    LoginListEdit = "editLoginList",

    // ------------------------------ uGate ------------------------------
    UGateList = "uGateList",
    UGateAdd = "addUGate",
    UGateEdit = "editUGate",

    // ------------------------------ connector ------------------------------
    ConnectorList = "connectorList",
    ConnectorAdd = "addConnector",
    ConnectorEdit = "editConnector",

    // ------------------------------ client agent setting ------------------------------
    ClientAgent = "clientAgent",

    // ------------------------------ team setting ------------------------------
    TeamSetting = "teamSetting",

    // ------------------------------ idp integration ------------------------------
    IdPIntegration = "idPIntegration",
    MicrosoftIdpAdd = "microsoftIdpAdd",
    GoogleIdpAdd = "googleIdpAdd",
    GithubIdpAdd = "githubIdpAdd",
    IdpEdit = "idpEdit",

    // ------------------------------ client application ------------------------------
    ClientList = "clientList",
    ClientApplicationAdd = "addClientApplication",
    ClientApplicationEdit = "editClientApplication",

    // ------------------------------ sys log ------------------------------
    UserLog = "userLog",
    DeviceLog = "deviceLog",
    ResourceLog = "resourceLog",

    // ------------------------------ my menu ------------------------------
    Profile = "profile",

    // ------------------------------ otp ------------------------------
    OtpAcquire = "otp-acquire",

    // ------------------------------ totp ------------------------------
    TotpAuth = "totp-auth",
    RecoveryCodes = "recovery-codes",
    RecoveryCodesView = "recovery-codes-view",
    RecoveryCodesPrint = "recovery-codes-print",

    // ------------------------------ notification ------------------------------
    NotificationList = "notification-list",
    NotificationDetail = "notification-detail",

    // ------------------------------ error ------------------------------
    Error403 = "Error-403",
    Error404 = "Error-404",
    Error500 = "Error-500",
}